import { Avatar } from "@mui/material";
import MuiClickable from "components/MuiExtras/MuiClickable";
import { UserIdResolver, UsernameResolver } from "components/UsernameInspect";
import HtmlUtils from "lib/HtmlUtils";
import { UserEntityModel, UserShortView } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from 'react-i18next';
import { RoutePaths } from "routes/RouteConfig";

interface IProps {
    user: UserEntityModel | UserShortView;
}

const UserProfileAvatar: React.FC<IProps> = ({ user }) => {
    const { t } = useTranslation();
    const id = UserIdResolver(user);

    return (
        <MuiClickable
            title={t("Components.UserProfileAvatar.TitleText")}
            onClick={() => HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", id))}
        >
            <Avatar src={user.thumbnailUrl} title={UsernameResolver(user)} />
        </MuiClickable>
    );
};

export default UserProfileAvatar;
